import React, { Component } from 'react';
import BaseLayout from '../../templates/base';
import FoliosTable from '../../elements/projects/folios';
import Loading from "../../elements/loading";

class ReportFolios extends Component {
	render() {
		const {projects} = this.props;
		return(
			projects.isFetching ? <Loading message="Cargando..."/>:<FoliosTable {...this.props}/>
		);
	}

	componentWillMount() {
		let {modality} = this.props.match.params;
		this.props.projectsFolios(modality);
	}

	componentWillReceiveProps(nextprops) {
		if(nextprops.match.params !== this.props.match.params) {
			let {modality} = nextprops.match.params;
			this.props.projectsFolios(modality);
		}
	}
}

export default BaseLayout(ReportFolios,{
	title:"Asignación de Folios",
	subnav:{
		icon: 'fa-briefcase',
		name: 'Proyectos',
		actions: [
			{
				type: null,
				url: null,
				name: '',
				element: null
			}
		]
	},
	stateNav: false
})


// WEBPACK FOOTER //
// ./src/layouts/projects/folios.jsx